import UserRepository from "@/repositories/UserRepository";

export interface ImpersonationUser {
    uuid: string;
    username: string;
}

export default {
    state: {
        impersonationUsers: [],
    },
    getters: {
        getImpersonationUsers: (state: any) => state.impersonationUsers,
    },
    mutations: {
        setImpersonationUsers(state: any, payload: ImpersonationUser[]) {
            state.impersonationUsers = payload;
        },
    },
    actions: {
        fetchImpersonationUsers({ commit, state }: any, search: string) {
            return new Promise((resolve: (value: ImpersonationUser[]) => void, reject: (value: object) => void) => {
                UserRepository.get({
                    filters: {
                        username: search,
                    },
                    fields: [
                        "uuid",
                        "username",
                    ]
                }).then((users: object[]) => {
                    commit("setImpersonationUsers", users);
                    resolve(users as ImpersonationUser[]);
                }).catch((error: any) => {
                    reject(error);
                });
            });
        }
    }
};
